<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Correspondências</h2>
      <p>
        Acompanhe suas correspondências e encomendas.
      </p>
    </b-col>
    <b-col
      cols="12"
      class="mt-0"
    >
      <list-correspondencias />
    </b-col>
  </b-row>
</template>

<script>
import ListCorrespondencias from './ListCorrespondencias.vue'

export default {
  components: {
    ListCorrespondencias,
  },
}
</script>
